module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "leave-active-class": "animated zoomOut"
    }
  }, [_c('li', {
    key: _vm.payload.id,
    staticClass: "proposal-line-item",
    class: 'proposal-' + _vm.payload.status
  }, [_c('span', {
    staticClass: "proposal-line-item-status"
  }, [_c('span', {
    staticClass: "proposal-line-item-comments"
  }, [_c('router-link', {
    attrs: {
      "to": '/a/document/' + _vm.payload.id + '/comments'
    }
  }, [_vm._v(_vm._s(_vm.payload.comments.length > 0 ? _vm.payload.comments.length : '0'))])], 1), _vm._v(" "), _c('span', {
    staticClass: "proposal-line-item-actual-status"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('proposals.status_types.' + _vm.payload.status)) + "\n      ")])]), _vm._v(" "), _c('span', {
    staticClass: "proposal-line-item-deets"
  }, [_c('span', {
    staticClass: "proposal-line-item-title"
  }, [(_vm.payload.status === 'draft') ? _c('router-link', {
    attrs: {
      "to": '/a/document/' + _vm.payload.id
    }
  }, [_vm._v(_vm._s(_vm.payload.title))]) : _vm._e(), _vm._v(" "), (_vm.payload.status !== 'draft') ? _c('router-link', {
    attrs: {
      "to": '/a/document/' + _vm.payload.id + '/preview'
    }
  }, [_vm._v(_vm._s(_vm.payload.title))]) : _vm._e()], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "proposal-line-item-team"
  }, [_vm._l((_vm.limit(_vm.commenters, 0, 6)), function(commenter) {
    return _c('li', [_c('team-member-avatar', {
      attrs: {
        "subject": commenter,
        "height": "45px",
        "width": "45px"
      }
    })], 1)
  }), _vm._v(" "), (_vm.commenters && _vm.commenters.length >= 7) ? _c('li', [_c('link-popover', [_c('div', {
    staticClass: "more-team-members"
  }, [_c('i', {
    staticClass: "icon icon-more"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.limit(_vm.commenters, 6)), function(commenter) {
    return _c('div', {
      class: {
        'active': commenter.isActive
      }
    }, [_c('span', {
      staticClass: "activity-indicator"
    }), _vm._v(" " + _vm._s(commenter.name))])
  }))])], 1) : _vm._e()], 2), _vm._v(" "), _c('span', {
    staticClass: "proposal-line-item-options"
  }, [_c('a', {
    staticClass: "watch",
    on: {
      "click": function($event) {
        _vm.toggleWatch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg",
    class: {
      'fa-eye': !_vm.isWatched, 'fa-eye-slash': _vm.isWatched
    }
  })]), _vm._v(" "), (_vm.payload.status !== 'draft') ? _c('router-link', {
    staticClass: "analytics",
    attrs: {
      "title": "Analytics",
      "to": '/a/document/' + _vm.payload.id + '/analytics'
    }
  }, [_c('i', {
    staticClass: "icon icon-analytics"
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "chat",
    attrs: {
      "title": "Document Comments",
      "to": '/a/document/' + _vm.payload.id + '/comments'
    }
  }, [_c('i', {
    staticClass: "icon icon-chat"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "edit",
    attrs: {
      "title": "Edit Document",
      "to": '/a/document/' + _vm.payload.id
    }
  }, [_c('i', {
    staticClass: "icon icon-edit"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "title": "Make a Copy"
    },
    on: {
      "click": _vm.copyDocument
    }
  }, [_c('i', {
    staticClass: "icon icon-doc-copy"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "Delete Document"
    }
  }, [_c('i', {
    staticClass: "icon icon-trash",
    on: {
      "click": function($event) {
        _vm.deletePayload()
      }
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d8e8e20","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/document-line-item.vue
// module id = 525
// module chunks = 0